import React, {
  Fragment,
  useState,
  useEffect,
  useRef,
  useCallback,
} from "react";
import {
  useGetCitiesQuery,
  useGetCompanyListQuery,
  useGetFilterOptionsQuery,
  useGetHomeDataAndTestimonialQuery,
  useGetHomeSkillsQuery,
} from "../Store/api/CommonApi";
import { Link, useNavigate } from "react-router-dom";
import bannerImage from "../Assets/img/image.png";
import EmpBanner from "../Assets/img/image-2.png";
import PcLogo from "../Assets/img/PC-logo.png";

function NewHome() {
  const [searchInput, setSearchInput] = useState({
    keyword: "",
    location: "",
    experience: "",
    skill: "",
    job_types: "",
    hotjob: "",
    postdate: "",
  });
  const [companies, setCompanies] = useState([]);
  const [hotJobs, setHotJobs] = useState([]);
  const [cities, setCities] = useState([]);
  const [experiences, setExperienceOption] = useState({});
  const [path, setPath] = useState("");
  const cityApi = useGetCitiesQuery();
  const OptionApi = useGetFilterOptionsQuery();
  const { data, isError } = useGetCompanyListQuery();
  const { data: HomeData } = useGetHomeDataAndTestimonialQuery();
  const testimonialsData = HomeData?.data[0]?.testimonials || [];
  const { data: HomeSkills } = useGetHomeSkillsQuery();
  const homeSkills = HomeSkills?.data || [];
  const navigate = useNavigate();

  const Logos = HomeData?.data[0] ? HomeData?.data[0]?.logos : [];

  useEffect(() => {
    if (data?.path) {
      setCompanies(data?.data);
      setHotJobs(data?.hotjobs);
      setPath(data?.path);
    }
  }, [data?.path]);

  useEffect(() => {
    if (OptionApi?.data) {
      setExperienceOption(OptionApi?.data?.data?.experience);
    }
  }, [OptionApi?.data, setExperienceOption]);

  const getCities = useCallback(
    (cities) => {
      let cityArray = [];
      if (cities.length > 0) {
        for (let index = 0; index < cities.length; index++) {
          cityArray.push(
            <option value={cities[index]["id"]} key={index}>
              {cities[index]["city_name"]}
            </option>,
          );
        }
        setCities(cityArray);
      }
    },
    [setCities],
  );

  const handleSearch = useCallback(
    (e) => {
      e.preventDefault();
      let location = window.$("#location").val();
      let experience = window.$("#experience").val();
      let searchData = {
        ...searchInput,
        location: location,
        experience: experience,
      };
      setSearchInput(searchData);
      const u = new URLSearchParams(searchData).toString();
      navigate(`/jobs?${u}`);
    },
    [setSearchInput, searchInput, navigate],
  );

  useEffect(() => {
    if (cityApi?.data) {
      getCities(cityApi?.data?.data);
    }
  }, [cityApi?.data, getCities]);

  const [currentIndex, setCurrentIndex] = useState(0);
  const trackRef = useRef(null);
  const scrollerRef = useRef(null);
  const [selectedJob, setSelectedJob] = useState(null);

  // Memoized navigation functions
  const nextTestimonial = useCallback(() => {
    setCurrentIndex((prevIndex) =>
      prevIndex === testimonialsData.length - 1 ? 0 : prevIndex + 1,
    );
  }, [testimonialsData]);

  const prevTestimonial = useCallback(() => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? testimonialsData.length - 1 : prevIndex - 1,
    );
  }, [testimonialsData]);

  // Auto-slide effect
  useEffect(() => {
    if (testimonialsData.length === 0) return; // Guard against empty data
    const interval = setInterval(() => {
      nextTestimonial();
    }, 10000);

    return () => clearInterval(interval); // Cleanup on unmount
  }, [nextTestimonial, testimonialsData]); // dependency now safely memoized

  // Update the track transform whenever currentIndex changes
  useEffect(() => {
    if (trackRef.current) {
      trackRef.current.style.transform = `translateX(-${currentIndex * 100}%)`;
    }
  }, [currentIndex]);

  // Scroll jobs left/right
  const scrollJobs = useCallback(
    (direction) => {
      if (scrollerRef.current) {
        const scrollAmount = scrollerRef.current.clientWidth;
        console.log(scrollAmount, direction);

        scrollerRef.current.scrollBy({
          left: direction * (scrollAmount - 70),
          behavior: "smooth",
        });
      }
    },
    [hotJobs],
  );

  // Open job panel
  const openJob = useCallback(
    (id) => {
      const job = hotJobs.find((j) => j.id === id);
      if (job) setSelectedJob(job);
    },
    [hotJobs],
  );

  // Close job panel
  const closePanel = useCallback(() => setSelectedJob(null), []);

  return (
    <Fragment>
      <section className="max-w-7xl mx-auto px-6 pt-16 pb-20 text-center">
        <h1 className="text-4xl md:text-4xl font-bold text-gray-900 mb-6">
          {HomeData?.data[0]?.main_heading ||
            "Find Inclusive Careers That Truly Matter ."}
        </h1>
        <p className="text-lg text-gray-600 max-w-2xl mx-auto mb-10">
          {HomeData?.data[0]?.secondry_heading ||
            "Connecting authentic identities with inclusive opportunities ."}
        </p>
        {/* SEARCH BAR */}
        <form onSubmit={handleSearch}>
          <div className="bg-white shadow-xl rounded-2xl p-4 md:p-6 flex flex-col md:flex-row gap-4 max-w-4xl mx-auto">
            {/* KEYWORD */}
            <div className="flex items-center gap-2 flex-1 border rounded-xl px-4 py-3">
              <i className="fas fa-search text-gray-400" />
              <input
                name="search"
                type="text"
                placeholder="Search jobs or skills"
                className="w-full border-none outline-none"
                onChange={(e) =>
                  setSearchInput({
                    ...searchInput,
                    keyword: e.target.value,
                  })
                }
                required
              />
            </div>
            {/* LOCATION */}
            <div className="flex items-center gap-2 flex-1 border rounded-xl px-4 py-3">
              <i className="fas fa-map-marker-alt text-gray-400" />
              <select
                className="w-full border-none outline-none bg-transparent text-gray-600"
                id="location"
              >
                <option value="">Location</option>
                {cities}
              </select>
            </div>
            {/* EXPERIENCE */}
            <div className="flex items-center gap-2 flex-1 border rounded-xl px-4 py-3">
              <i className="fas fa-briefcase text-gray-400" />
              <select className="w-full border-none outline-none bg-transparent text-gray-600">
                <option value="">Experience</option>
                {Object.keys(experiences).length > 0 &&
                  Object.keys(experiences).map((exp, i) => {
                    return (
                      <option value={exp} key={i}>
                        {experiences[exp]}
                      </option>
                    );
                  })}
                {/* <option>Fresher</option>
                <option>1-3 Years</option>
                <option>3-5 Years</option>
                <option>5-8 Years</option>
                <option>8-12 Years</option>
                <option>12+ Years</option> */}
              </select>
            </div>
            {/* BUTTON */}
            <button
              type="submit"
              className="rounded-xl px-10 bg-indigo-600 text-white py-3"
            >
              Search
            </button>
          </div>
        </form>
      </section>

      {/* <button
        //to={`/company-detail/${item?.id}/${(item?.company_name.toLowerCase()).replaceAll(" ", "-")}`}
        //onClick={() =>navigate(`/rise/citi`,{ state: { id: 11 } })}
        onClick={() => navigate(`/rise/citi`,{ state: { id: 12 } })}
        className="genric-btn info circle arrow"
      >
        View Jobs
        <span className="lnr lnr-arrow-right" />
      </button> */}
      {/* TRUST SECTION */}
      {HomeData?.data[0] && (<section
        className="max-w-6xl mx-auto px-6 grid grid-cols-3 gap-4 mb-20"
        dangerouslySetInnerHTML={{
          __html:
            HomeData?.data[0]?.employer_file_data +
            HomeData?.data[0]?.candidate_file_data +
            HomeData?.data[0]?.opportunity_file_data,
        }}
      >
        
      </section>)}
      {/* CATEGORY BANNER */}
      <section className="max-w-6xl mx-auto px-6 mb-16">
        <div className="w-full h-[220px] md:h-[260px] rounded-2xl overflow-hidden shadow-lg">
          <a href={HomeData?.data[0]?.career_link} target="_blank">
            <img
              //src={bannerImage}
              src={HomeData?.data[0]?.career_banner}
              alt="Inclusive careers banner"
              className="w-full h-full object-cover"
            />
          </a>
        </div>
      </section>
      {/* BROWSE CATEGORY */}
      <section className="max-w-6xl mx-auto px-6 mb-20">
        <h2 className="text-2xl font-semibold mb-8 text-center">
          Browse By Category
        </h2>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
          {homeSkills.length > 0 &&
            homeSkills.map((skill) => (
              <Link
                to={`jobs?skill=${skill.id}`}
                key={skill.id}
                className="rounded-2xl shadow hover:shadow-lg transition cursor-pointer p-6 text-center font-medium text-gray-700"
              >
                {skill.skill_title}
              </Link>
            ))}
        </div>
      </section>
      {/* FEATURED JOBS */}
      <section className="max-w-6xl mx-auto px-6 mb-20 relative">
        {/* Header */}
        <div className="flex justify-between items-center mb-8">
          <h2 className="text-2xl font-semibold">Hot Jobs</h2>
          <Link to="/jobs" className="border rounded-xl px-6 py-2">
            View All Jobs
          </Link>
        </div>

        <div className="relative">
          {/* Left Scroll Button */}
          <button
            onClick={() => scrollJobs(-1)}
            className="absolute left-0 top-1/2 -translate-y-1/2 bg-white shadow-md rounded-full w-10 h-10 z-10 flex items-center justify-center"
          >
            <i className="fas fa-chevron-left" />
          </button>
          {/* Job Scroller */}
          <div
            ref={scrollerRef}
            className="flex gap-6 overflow-x-auto scroll-smooth no-scrollbar px-10"
          >
            {hotJobs.map((job) => (
              <div
                key={job.id}
                className="min-w-full md:min-w-[48%] rounded-2xl shadow-lg hover:shadow-2xl transition cursor-pointer p-10 relative"
                onClick={() => openJob(job.id)}
              >
                {/* Top row */}
                <div className="flex justify-between items-start mb-4">
                  <div className="flex items-center gap-3">
                    {job.profile_image && (
                      <img
                        src={encodeURI(job?.profile_image)}
                        alt={job.job_title}
                        title={job.icon_title}
                        className="h-12 w-12 object-contain"
                      />
                    )}
                  </div>
                  {job.identity_labels && (
                    <span className="bg-gray-200 text-xs px-3 py-1 rounded-full">
                      {job.identity_labels}
                    </span>
                  )}
                </div>

                {/* Job details */}
                <h3 className="text-xl font-semibold text-gray-900 mb-3">
                  {job.job_title}
                </h3>
                {job.locations && (
                  <p className="text-sm text-gray-600 mb-2">{job.locations}</p>
                )}
                {job.experience_label && (
                  <p className="text-sm text-gray-500 mb-4">
                    {job.experience_label}
                  </p>
                )}
                {job.job_details && (
                  <p className="text-gray-600 text-sm HotJobText">
                    {job.job_details.replace(/<[^>]*>/g, "")}
                  </p>
                )}
              </div>
            ))}
          </div>

          {/* Right Scroll Button */}
          <button
            onClick={() => scrollJobs(1)}
            className="absolute right-0 top-1/2 -translate-y-1/2 bg-white shadow-md rounded-full w-10 h-10 flex items-center justify-center"
          >
            <i className="fas fa-chevron-right" />
          </button>
        </div>

        {/* Job Panel */}
        <div
          className={`slide-panel fixed right-0 top-0 h-full w-full md:w-[420px] bg-white shadow-2xl z-50 p-6 overflow-y-auto ${selectedJob ? "active" : ""}`}
        >
          <div className="flex justify-between items-center mb-6">
            <h2 className="text-xl font-bold">{selectedJob?.job_title}</h2>
            <button onClick={closePanel} className="text-gray-600">
              <i className="fas fa-times"></i>
            </button>
          </div>
          <p className="text-gray-600 mb-2">{selectedJob?.locations}</p>
          <p className="text-gray-500 mb-4">{selectedJob?.experience_label}</p>
          <p
            className="text-gray-700 mb-6 HotView"
            dangerouslySetInnerHTML={{ __html: selectedJob?.job_details }}
          ></p>
          <button
            onClick={() => navigate(`/job-detail/${selectedJob?.id}`)}
            className="w-full bg-indigo-600 text-white py-3 rounded-xl"
          >
            Apply Now
          </button>
        </div>
      </section>
      {/* EMPLOYER BANNER */}
      <section className="max-w-6xl mx-auto px-6 mb-10">
        <div className="w-full h-[200px] md:h-[240px] rounded-2xl overflow-hidden shadow-lg">
          <a href={HomeData?.data[0]?.employer_link}>
            <img
              //src={EmpBanner}
              src={HomeData?.data[0]?.employer_banner}
              alt="Employers banner"
              className="w-full h-full object-cover"
            />
          </a>
        </div>
      </section>
      {/* EMPLOYERS */}
      <section className="bg-white py-16 overflow-hidden">
        <div className="max-w-6xl mx-auto px-6 text-center mb-10">
          <h2 className="text-2xl font-semibold">
            Trusted Inclusive Employers
          </h2>
        </div>
        {Logos && (
          <div className="logo-slider">
            <div className="logo-track">
              {Logos.map((v, i) => {
                return <img key={i} src={v} alt="the pride circle" />;
              })}
            </div>
          </div>
        )}

        {/* <img
              src="https://upload.wikimedia.org/wikipedia/commons/4/44/Microsoft_logo.svg"
              alt="the pride circle"
            />
            <img
              src="https://upload.wikimedia.org/wikipedia/commons/a/a9/Amazon_logo.svg"
              alt="the pride circle"
            />
            <img
              src="https://upload.wikimedia.org/wikipedia/commons/f/fa/Apple_logo_black.svg"
              alt="the pride circle"
            />
            <img
              src="https://upload.wikimedia.org/wikipedia/commons/2/2f/Google_2015_logo.svg"
              alt="the pride circle"
            />
            <img
              src="https://upload.wikimedia.org/wikipedia/commons/0/08/Netflix_2015_logo.svg"
              alt="the pride circle"
            />
            <img
              src="https://upload.wikimedia.org/wikipedia/commons/5/51/IBM_logo.svg"
              alt="the pride circle"
            />
            
            <img
              src="https://upload.wikimedia.org/wikipedia/commons/4/44/Microsoft_logo.svg"
              alt="the pride circle"
            />
            <img
              src="https://upload.wikimedia.org/wikipedia/commons/a/a9/Amazon_logo.svg"
              alt="the pride circle"
            />
            <img
              src="https://upload.wikimedia.org/wikipedia/commons/f/fa/Apple_logo_black.svg"
              alt="the pride circle"
            />
            <img
              src="https://upload.wikimedia.org/wikipedia/commons/2/2f/Google_2015_logo.svg"
              alt="the pride circle"
            />
            <img
              src="https://upload.wikimedia.org/wikipedia/commons/0/08/Netflix_2015_logo.svg"
              alt="the pride circle"
            />
            <img
              src="https://upload.wikimedia.org/wikipedia/commons/5/51/IBM_logo.svg"
              alt="the pride circle"
            /> */}
        {/* </div>
        </div> */}
      </section>
      {/* TESTIMONIAL SLIDER */}
      <section className="max-w-4xl mx-auto px-6 py-20 text-center relative">
        <div className="overflow-hidden relative">
          <h2 className="text-2xl font-semibold">Testimonials</h2>
          <br />
          <br />
          <div
            ref={trackRef}
            id="testimonialTrack"
            className="flex transition-transform duration-500"
          >
            {testimonialsData.map((t, idx) => (
              <div key={idx} className="min-w-full px-6">
                <h3>
                  <strong>
                    <i>{t.heading}</i>
                  </strong>
                </h3>
                <br />
                {Array.from({ length: t?.star_count ?? 3 }).map((_, index) => {
                  return (
                    <i
                      key={index}
                      className="fas fa-star text-yellow-400 mb-4 text-2xl"
                    />
                  );
                })}
                {/* <i className="fas fa-star text-yellow-400 mb-4 text-2xl" />
                <i className="fas fa-star text-yellow-400 mb-4 text-2xl" />
                <i className="fas fa-star text-yellow-400 mb-4 text-2xl" /> */}
                <p className="text-lg text-gray-700 mb-4">{t.message}</p>
                <div className="text-sm text-gray-500">{t.member}</div>
              </div>
            ))}
            {/* TESTIMONIAL 1 */}
            {/* <div className="min-w-full px-6">
                     <i className="fas fa-star text-yellow-400 mb-4 text-2xl" />
                     <p className="text-lg text-gray-700 mb-4">
                        "Through this platform, I found an organization that truly
                        values inclusion and authenticity."
                     </p>
                     <div className="text-sm text-gray-500">
                        – Candidate Success Story
                     </div>
                  </div> */}
            {/* TESTIMONIAL 2 */}
            {/* <div className="min-w-full px-6">
                     <i className="fas fa-star text-yellow-400 mb-4 text-2xl" />
                     <p className="text-lg text-gray-700 mb-4">
                        "A powerful community that connects talent with employers who
                        actually care."
                     </p>
                     <div className="text-sm text-gray-500">– Community Member</div>
                  </div> */}
            {/* TESTIMONIAL 3 */}
            {/* <div className="min-w-full px-6">
                     <i className="fas fa-star text-yellow-400 mb-4 text-2xl" />
                     <p className="text-lg text-gray-700 mb-4">
                        "This platform helped me find a role where I could bring my full
                        self to work."
                     </p>
                     <div className="text-sm text-gray-500">– Product Designer</div>
                  </div> */}
          </div>
        </div>
        {/* NAV BUTTONS */}
        <div className="flex justify-center gap-4 mt-8">
          <button
            //onclick="prevTestimonial()"
            onClick={prevTestimonial}
            className="px-4 py-2 border rounded-lg"
          >
            <i className="fas fa-arrow-left" />
          </button>
          <button
            //onclick="nextTestimonial()"
            onClick={nextTestimonial}
            className="px-4 py-2 border rounded-lg"
          >
            <i className="fas fa-arrow-right" />
          </button>
        </div>
      </section>
      {/* CTA */}
      <section className="bg-indigo-600 py-16 text-center text-white">
        <h2 className="text-white text-2xl md:text-3xl font-semibold mb-6">
          Ready to Take the Next Step?
        </h2>
        <div className="flex justify-center gap-4">
          {/* <Link
            to="/jobs"
            className="bg-white text-indigo-600 px-6 py-3 rounded-xl"
          >
            Explore Jobs
          </Link> */}

          <Link
            to="/jobs"
            className="border border-white px-6 py-3 rounded-xl"
          >
            Explore Jobs
          </Link>

          <Link
            to="/resume"
            className="bg-white text-indigo-600 px-6 py-3 rounded-xl"
          >
            Upload Your Resume
          </Link>


          <Link
            target="_blank"
            to="https://recruiter.thepridecircle.com/login"
            className="border border-white px-6 py-3 rounded-xl"
          >
            Post a Job
          </Link>
        </div>
      </section>
    </Fragment>
  );
}

export default NewHome;
